import { useEffect } from 'react';
import { supabase } from '../supabaseClient';

/**
 * Hiver live chat (Chatwoot SDK) for the customer area. Loads the SDK once,
 * shows the bubble only while UserLayout is mounted (see index.css), and
 * tells Hiver who the signed-in user is.
 *
 * useHiverChat(currentUser);
 */
const SCRIPT_ID = 'hiver-chat-sdk';
const SDK_URL = 'https://chat-widget.hiverhq.com/chat-widget/js/sdk.js';
const WEBSITE_TOKEN = 'J9aJBpFXNXBwCRKRWZJmBz9M';
const VISIBLE_CLASS = 'hiver-chat-visible';

let widgetReady = false;
window.addEventListener('hiver:widget-ready', () => { widgetReady = true; });

// Clear the conversation on any sign-out so the next person on a shared PC can't see it.
supabase.auth.onAuthStateChange((event) => {
  if (event === 'SIGNED_OUT') window.$chatwoot?.reset();
});

const identify = (user) => {
  // Hiver throws without an email/name.
  if (!user?.email) return;
  window.$chatwoot?.setUser(user.id, {
    email: user.email,
    name: user.full_name || user.email,
    ...(user.company_name ? { company_name: user.company_name } : {}),
  });
};

export default function useHiverChat(currentUser) {
  useEffect(() => {
    document.body.classList.add(VISIBLE_CLASS);
    if (!document.getElementById(SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = SDK_URL;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        window.hiverChatWidgetSettings = { ...window.hiverChatWidgetSettings, position: 'right' };
        window.chatwootSDK.run({ websiteToken: WEBSITE_TOKEN, baseUrl: '' });
      };
      document.body.appendChild(script);
    }
    return () => document.body.classList.remove(VISIBLE_CLASS);
  }, []);

  useEffect(() => {
    if (!currentUser) return undefined;
    if (widgetReady) {
      identify(currentUser);
      return undefined;
    }
    const onReady = () => identify(currentUser);
    window.addEventListener('hiver:widget-ready', onReady);
    return () => window.removeEventListener('hiver:widget-ready', onReady);
  }, [currentUser]);
}
